'use client';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Query } from './Query';
import { buildConfiguration, getDoc } from '../lib/useContent';
export const CmsContent = ({ name, id = '', children, getContent = (data) => data, filter = {}, limit = 100, component, componentProps = {} }) => {
    const [doc] = useState(getDoc(id));
    const { variables } = buildConfiguration({ id, name, filter, limit });
    return (_jsx(_Fragment, { children: _jsx(Query, { doc: doc, variables: variables, getData: getContent, component: component, componentProps: componentProps, children: children }) }));
};
